import React from "react";
import classnames from "classnames";
import { Dropdown } from "@my-scoot/component-library-legacy";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import ExlyImage from "common/Components/ExlyImage";
import { useThankYouBuilderChoiceModal } from "./useThankYouBuilderChoiceModal";
import {
  thank_you_builder_options,
  thank_you_builder_types,
} from "features/ThankYouPages/constants/ThankYouPages.constants";
import ExlyLoader from "ui/modules/ExlyLoader";
import {
  THANK_YOU_BUILDER_CHOICE_TYPES,
  THANK_YOU_BUILDER_CREATE_FROM_SCRATCH_VALUE,
  THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS,
} from "./ThankYouBuilderChoiceModal.constants";

export const ThankYouBuilderChoiceModal = ({
  open,
  onClose,
  listingUuid,
  paymentLinkUuid,
  isCombo = false,
  pageType,
}) => {
  const {
    selectedBuilder,
    setSelectedBuilder,
    selectedPageUuid,
    setSelectedPageUuid,
    thankYouPages,
    loading,
    processing,
    handleContinue,
    handleClose,
    primaryBtnText,
  } = useThankYouBuilderChoiceModal({
    listingUuid,
    paymentLinkUuid,
    isCombo,
    pageType,
    open,
    onClose,
  });

  const pageOptions = [
    {
      value: THANK_YOU_BUILDER_CREATE_FROM_SCRATCH_VALUE,
      label: THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.CREATE_FROM_SCRATCH_LABEL,
    },
    ...thankYouPages.map((page) => ({
      value: page.uuid,
      label: page.title || "Untitled Thank You Page",
    })),
  ];

  const handleModalClose = () => {
    handleClose();
  };

  return (
    <ExlyModal
      open={open}
      onClose={handleModalClose}
      primaryBtnText={
        <>
          {primaryBtnText}&nbsp;
          <ArrowForwardRoundedIcon className="!tw-w-[18px] !tw-h-[18px]" />
        </>
      }
      onPrimaryBtnClick={handleContinue}
      primaryBtnProps={{
        fullWidth: true,
        loading: processing,
        disabled: loading || !selectedBuilder,
      }}
      showSecondaryBtn={false}
      title={THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.TITLE}
      className="p-0"
      modal_props={{
        modalPaperClassName: "!tw-min-w-full md:!tw-min-w-[570px]",
      }}
    >
      <div className="tw-p-4 tw-max-w-[570px] tw-flex tw-flex-col tw-gap-4">
        {loading ? (
          <div className="tw-flex tw-justify-center tw-py-8">
            <ExlyLoader />
          </div>
        ) : (
          <>
            <div>
              <div className="tw-text-[14px] tw-font-medium tw-leading-[17.09px] tw-mb-[6px]">
                {THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.BUILDER_HEADING}
                <span className="text-danger">*</span>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2">
                {Object.values(thank_you_builder_options).map((item) => (
                  <div
                    className={classnames(
                      "tw-flex tw-gap-4 tw-p-2 tw-border tw-border-solid tw-border-[#f1f0ef] tw-rounded-[12px] tw-cursor-pointer",
                      item.value ===
                        (selectedBuilder ===
                        THANK_YOU_BUILDER_CHOICE_TYPES.CLASSIC
                          ? thank_you_builder_types.classic
                          : thank_you_builder_types.advanced) &&
                        "tw-border-[1.5px] tw-border-solid !tw-border-[#493ab1] tw-bg-[#fbfbfe]"
                    )}
                    key={item.value}
                    onClick={() =>
                      setSelectedBuilder(
                        item.value === thank_you_builder_types.classic
                          ? THANK_YOU_BUILDER_CHOICE_TYPES.CLASSIC
                          : THANK_YOU_BUILDER_CHOICE_TYPES.ADVANCED
                      )
                    }
                  >
                    <ExlyImage
                      className="tw-w-16 tw-h-16 tw-rounded-[8px]"
                      src={item.url}
                      alt={item.heading}
                    />
                    <div className="tw-flex tw-flex-col tw-justify-center tw-gap-2">
                      <div className="tw-text-[14px] tw-font-medium tw-leading-[17.09px] tw-text-[#1c274c]">
                        {item.heading}
                      </div>
                      <div className="tw-text-[12px] tw-font-normal tw-leading-[14.32px] tw-text-[#8b91a5]">
                        {item.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {selectedBuilder === THANK_YOU_BUILDER_CHOICE_TYPES.ADVANCED &&
              thankYouPages.length > 0 && (
                <div>
                  <div className="tw-text-[14px] tw-font-medium tw-leading-[17.09px] tw-mb-[6px]">
                    {THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.SELECT_PAGE_HEADING}
                  </div>
                  <div className="small text-muted mb-2">
                    {
                      THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.PAGE_SELECT_DESCRIPTION
                    }
                  </div>
                  <Dropdown
                    fullWidth
                    size="small"
                    value={
                      selectedPageUuid ||
                      THANK_YOU_BUILDER_CREATE_FROM_SCRATCH_VALUE
                    }
                    options={pageOptions}
                    placeholder={
                      THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.PAGE_SELECT_PLACEHOLDER
                    }
                    dropdownLabel={{
                      label:
                        THANK_YOU_BUILDER_CHOICE_MODAL_TEXTS.PAGE_SELECT_LABEL,
                      size: "small",
                      weight: "semi-bold",
                    }}
                    handleChange={(value) => {
                      setSelectedPageUuid(
                        value === THANK_YOU_BUILDER_CREATE_FROM_SCRATCH_VALUE
                          ? null
                          : value
                      );
                    }}
                  />
                </div>
              )}
          </>
        )}
      </div>
    </ExlyModal>
  );
};
